import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormChangeDetectionService {

  /**
   * Tracks original values for a form to enable change detection
   */
  private originalValues: Record<string, any> = {};

  /**
   * Sets the original values for change detection
   */
  setOriginalValues(form: FormGroup, data: any): void {
    this.originalValues = { ...data };
  }

  /**
   * Checks if a specific field has changed from its original value
   */
  hasFieldChanged(form: FormGroup, fieldName: string): boolean {
    const currentValue = form.get(fieldName)?.value;
    const originalValue = this.originalValues[fieldName];
    return currentValue !== originalValue;
  }

  /**
   * Checks if any of the specified fields have changed
   */
  hasAnyFieldChanged(form: FormGroup, fieldNames: string[]): boolean {
    return fieldNames.some(field => this.hasFieldChanged(form, field));
  }

  /**
   * Gets only the fields that have changed from their original values
   */
  getChangedFields(form: FormGroup, fieldNames: string[]): any {
    const updates: any = {};

    fieldNames.forEach(field => {
      if (this.hasFieldChanged(form, field)) {
        updates[field] = form.get(field)?.value;
      }
    });

    return updates;
  }

  /**
   * Resets the original values (call when form is reset)
   */
  reset(): void {
    this.originalValues = {};
  }
}
